"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/register");
const Actions = require("../../actions/register");
const validation_1 = require("../../utils/validation");
const errorHandling_1 = require("../../utils/errorHandling");
function register(action$, _store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.REGISTER_REQUEST), (0, operators_1.mergeMap)((action) => (0, validation_1.isEmail)('email')(action.payload.email).fold((validation) => (0, rxjs_1.of)(Actions.updateValidation({ validation })), (_) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: action.payload,
        url: `${baseUrl}api/bid/register`
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.registerSuccess())), (0, operators_1.catchError)((error) => {
        if (error.status === 660) {
            return (0, rxjs_1.of)(Actions.registerDisabled(error.status));
        }
        else {
            return (0, rxjs_1.of)(Actions.registerFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)));
        }
    })))));
}
exports.register = register;
//# sourceMappingURL=index.js.map